export default "__VITE_ASSET__11ctqB$P__"